import type { SVGProps } from 'react';

const IconChevronRightOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M5.79998 4.47375C5.53998 4.73375 5.53998 5.15375 5.79998 5.41375L8.38665 8.00042L5.79998 10.5871C5.53998 10.8471 5.53998 11.2671 5.79998 11.5271C6.05998 11.7871 6.47998 11.7871 6.73998 11.5271L9.79998 8.46708C10.06 8.20708 10.06 7.78708 9.79998 7.52708L6.73998 4.46708C6.48665 4.21375 6.05998 4.21375 5.79998 4.47375Z" />
  </svg>
);

export default IconChevronRightOutline;
